var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from '@mui/system';
export function InfoBlock(_a) {
    var title = _a.title, text = _a.text, className = _a.className;
    return (_jsxs(Wrapper, __assign({ className: className }, { children: [_jsx(Title, { children: title }), _jsx(Body, { children: text })] })));
}
export default InfoBlock;
export var Wrapper = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        display: 'grid',
        gap: '.75rem',
        border: "2px solid ".concat(theme.palette.primary.main),
        position: 'relative',
        borderRadius: '10px',
    });
});
export var Title = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        border: "2px solid ".concat(theme.palette.primary.main),
        marginRight: 'auto',
        padding: '0.15rem 1rem',
        borderRadius: '4px',
        position: 'absolute',
        top: '-1.1rem',
        left: '0.2rem',
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
    });
});
export var Body = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        paddingLeft: '1rem',
        paddingRight: '1rem',
        paddingTop: '1.5rem',
        paddingBottom: '1rem',
    });
});
